import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

const CopyLink = ({ onClick }) => {

  return (
    <li>
      <button className='copy-link' onClick={onClick} >
        <p><FormattedMessage id='common.copy_link' /></p>
      </button>
    </li>
  )
}

export default CopyLink

CopyLink.propTypes = {
  onClick: PropTypes.func.isRequired
}
